import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMetricsReferences } from '/@/hooks/recommendation';
import { _ } from '/@/locale';
import { getSessionLanguage } from '/@/store/session/selectors';
import { convertSnakeToCamelCase } from '/@/utils/index';
import styles from './styles.module.css';

export const RangeReference = ({ referenceCodenames, theme, monochrome, maxWidth = true, hideTitle }) => {
    // NOTE: This component currently only works for metrics with a range of 5 values.
    const language = useSelector(getSessionLanguage);

    const [metricReferences, setMetricReferences] = useState();
    const [legends, setLegends] = useState();
    const { data: metrics } = useMetricsReferences({});

    useEffect(() => {
        if (metrics) {
            setMetricReferences(metrics.corn);
            if (referenceCodenames.length > 0) {
                const profile = convertSnakeToCamelCase(referenceCodenames[0]);
                setLegends(metrics.corn[profile]['legends']);
            } else {
                setLegends(metrics.corn.default['legends']);
            }
        }
    }, [metrics]);

    return (
        <div className={classNames(styles.root, maxWidth && styles.maxWidth)}>
            {!hideTitle && <div className={styles.title}>{_('Referencias')}</div>}
            <div className={styles.table}>
                <div className={styles.labels}>
                    <div />
                    {legends &&
                        legends.map((legend, index) => (
                            <div key={index} className={styles.label}>
                                {legend[language]}
                            </div>
                        ))}
                </div>
                {metricReferences &&
                    referenceCodenames.map((codename, index) => {
                        const camelCaseCodename = convertSnakeToCamelCase(codename);
                        return (
                            <div key={index} className={styles.reference}>
                                <div className={styles.name}>
                                    {metricReferences[camelCaseCodename]['title'][language]}
                                </div>
                                <div className={styles.values}>
                                    {metricReferences?.[camelCaseCodename]?.values.map((value, index) => (
                                        <div
                                            key={index}
                                            className={classNames(styles.value, styles[theme], styles['dot-5'], {
                                                [styles.monochrome]: monochrome,
                                            })}
                                        >
                                            {value[language]}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
